/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import axios from 'axios';
import { Graphql } from '@common/graphql';
import { apiConfig } from '@/config/apiConfig';
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { REINVITE_ORG } from '../../api/graphql';
import moment from 'moment-timezone';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator';

const getGraphQLModule = () => {
  return vappContainer.get<GraphqlServerModule>(GraphqlServerModule.name);
};

const LoginPageServ = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface ReInviteUserProps {
  email: string;
  firstName: string;
  lastName: string;
  invite: boolean;
  loginRestAPI: string;
  headers: any;
  termsOfUse: any;
}
export interface IReInviteUserMethods extends IPluginMethodMap {
  getReInviteUser(args: ReInviteUserProps): Promise<any>;
}
const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export class ReInviteUserService implements IAgentPlugin {
  readonly methods: IReInviteUserMethods;

  constructor() {
    this.methods = {
      getReInviteUser: this.getReInviteUser.bind(this),
    };
  }

  async getReInviteUser(args: ReInviteUserProps) {
    console.log(`args in invite user service`, args);
    const srv = LoginPageServ();

    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      if (client) {
        const res = await client.mutation(REINVITE_ORG, {
          input: {
            email: args,
          },
        });
        if (res?.data) {
          console.log(`table data`, res);
          return {
            ...res?.data,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
  }
}
